<template>
  <!--合同模板-->
  <el-container class="sys-contract">
    <el-main class="main-box">
      <div class="systemp-content">
        <div ref="contract" :is="typeName"></div>
      </div>
    </el-main>
    <el-aside width="180px" class="saide-right">
      <el-button
        type="danger"
        size="small"
        class="btn"
        @click="useTpl"
        :loading="loading"
        >下一步</el-button
      >
      <el-dropdown class="dropdown" trigger="click">
        <span class="el-dropdown-link">
          签章设置<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown" style="padding: 10px">
          <div style="margin-bottom: 10px">
            <el-switch
              v-model="needPresSign"
              active-text="保全章"
              active-color="#ec1c1cb3"
            ></el-switch>
          </div>
          <div>
            <el-switch
              v-model="needQifengSign"
              active-text="骑缝章"
              active-color="#ec1c1cb3"
            ></el-switch>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
    </el-aside>
  </el-container>
</template>

<script>
import Labor from "@/components/sys-contract/labor";
import Borrow from "@/components/sys-contract/borrow";
import Business from "@/components/sys-contract/business";
import Renting from "@/components/sys-contract/renting";
import Confidentiality from "@/components/sys-contract/confidentiality"; //保密协议
import Product from "@/components/sys-contract/product"; //产品协议
import exper from "@/components/sys-contract/exper"; // 体验签署模板
import { useTpl } from "@/assets/js/http-serve/http-sysTpl";
import { tempConvertToContract } from "@/assets/js/http-serve/http-methods";
import { isInDingTalk } from "@/assets/js/utils/ding-env";

export default {
  name: "sysContract",
  components: {
    Labor,
    Borrow,
    Business,
    Renting,
    exper,
    Product,
    Confidentiality
  },
  data () {
    return {
      typeName: this.$route.query.typeName,
      loading: false,
      needPresSign: true,
      needQifengSign: true
    };
  },
  mounted () { },
  methods: {
    useTpl: function () {
      this.loading = true;
      let data = this.$refs.contract.$data.form;
      let json = JSON.stringify(data);

      useTpl({ typeName: this.typeName }).then(data => {
        console.log("this.typeName", this.typeName);
        let d = data.data;
        let convertParam = {
          targetId: d.targetId,
          fileType: d.fileType,
          sign: d.sign,
          ts: d.ts,
          varList: json
        };
        tempConvertToContract(convertParam).then(data => {
          this.loading = false;
          let { href } = this.$router.resolve({
            path: "/applySign/toCreate",
            query: {
              contractId: d.targetId,
              sign: d.sign,
              ts: d.ts,
              contractName: "系统模板",
              items: data.data.items,
              docHash: data.data.docHash,
              fileType: d.fileType,
              needPresSign: this.needPresSign ? 1 : 0,
              needQifengSign: this.needQifengSign || 1
            }
          });

          this.$confirm("合同加载成功，立即前往发起签署？", "系统提示", {
            showConfirmButton: true,
            showCancelButton: false,
            type: "info"
          })
            .then(() => {
              isInDingTalk ? location.href = location.origin + href : window.open(window.location.origin + href, "_blank");
            })
            .catch(() => { });
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.systemp-content {
  box-sizing: border-box;
  margin: 0 auto;
  padding: 0 84px;
  width: 794px;
  height: calc(100vh - 220px);
  overflow-y: auto;
  -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);
  font-family: "宋体" !important;
  font-size: 14px;
}

.saide-right {
  box-sizing: border-box;
  border-left: 1px solid #f2f2f2;
  background-color: #fafafa;
  text-align: center;
  padding-top: 20px;

  .btn {
    width: 140px;
  }
  .dropdown {
    margin-top: 20px;

    .el-dropdown-link {
      cursor: pointer;
      color: #409eff;
    }
    .el-icon-arrow-down {
      font-size: 12px;
    }
  }
}

.sys-contract {
  margin: -20px;
}
</style>



// WEBPACK FOOTER //
// pages/tpl/add/sysContract.vue